import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

import type { GeoCountryModel } from '@models/types'

interface GeoCountryDetailsProps {
  geoCountry: GeoCountryModel,
  geoCountryFormPayload: UseFormPayload,
}

const GeoCountryDetails = (props: GeoCountryDetailsProps) => {
  const { geoCountryFormPayload } = props

  const {
    entityState: {
      active,
      calling_code,
      code,
      currency_code,
      currency_symbol,
      tax_rate,
      title,
    },
    errors,
    handlers,
  } = geoCountryFormPayload

  return (
    <DashboardModule title="Country Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field errorMessage={errors.code} label="* Country Code" marginTop={['large', 0]}>
            <input name="code" value={code} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Currency Code">
            <input name="currency_code" value={currency_code} type="text" {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Currency Symbol" marginTop={['large', 0]}>
            <input name="currency_symbol" value={currency_symbol} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Calling Code">
            <input name="calling_code" value={calling_code} type="text" {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Tax Rate" marginTop={['large', 0]}>
            <input min="0" name="tax_rate" value={tax_rate} type="number" {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Active">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              data-value-type="boolean"
              name="active"
              value={active}
              {...handlers}
            >
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default GeoCountryDetails
